import React, { useEffect, useState } from 'react';
import api from '../api/api';
import { useAuth } from '../context/AuthContext';

export default function QuotaModal() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPerks, setShowPerks] = useState(false);
  const { user } = useAuth();

  useEffect(() => {
    const handler = (e) => {
      setMessage(e.detail || 'Vous avez atteint votre quota cette semaine.');
      setOpen(true);
    };
    window.addEventListener('quota:reached', handler);
    return () => window.removeEventListener('quota:reached', handler);
  }, []);

  const lower = (message || '').toLowerCase();
  const type = lower.includes('limite atteinte pour')
    ? (lower.includes('recipe')
        ? 'recipe'
        : lower.includes('suggestion')
          ? 'suggestion'
          : lower.includes('iteration')
            ? 'iteration'
            : lower.includes('question')
              ? 'question'
              : null)
    : null;
  const labels = { recipe: 'Recettes', suggestion: 'Suggestions', iteration: 'Itérations', question: 'Questions YAQAM' };
  const actions = { recipe: 'générer des recettes', suggestion: 'obtenir des suggestions', iteration: 'itérer vos recettes', question: 'poser des questions à YAQAM' };
  const isFree = user?.subscription?.type === 'free';

  const close = () => { setOpen(false); setShowPerks(false); };

  const handleUpgrade = async () => {
    try {
      setLoading(true);
      const { data } = await api.post('/api/stripe/checkout-session');
      if (data?.url) window.location.href = data.url; else window.location.href = '/subscription';
    } catch (_) {
      window.location.href = '/subscription';
    } finally { setLoading(false); }
  };

  const handleManage = async () => {
    try {
      setLoading(true);
      const { data } = await api.post('/api/stripe/portal-session');
      if (data?.url) window.location.href = data.url; else window.location.href = '/subscription';
    } catch (_) {
      window.location.href = '/subscription';
    } finally { setLoading(false); }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50">
      <div className="absolute inset-0 bg-black/50" onClick={close} />
      <div className="absolute inset-0 flex items-center justify-center p-4">
        <div className="w-full max-w-lg bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden">
          <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
            <div className="font-semibold text-[#2C3E50] flex items-center gap-2">
              <span>Limite atteinte</span>
              {type && (
                <span className="text-xs bg-yellow-100 border border-yellow-200 text-yellow-900 px-2 py-0.5 rounded-full">{labels[type]}</span>
              )}
            </div>
            <button onClick={close} className="text-gray-400 hover:text-gray-600">✕</button>
          </div>

          <div className="px-5 py-4 space-y-3">
            <div className="text-sm text-gray-800">{message}</div>

            {type && isFree && (
              <div className="bg-yellow-50 border border-yellow-200 text-yellow-900 rounded-lg p-3">
                <div className="text-sm font-medium mb-1">Passez à Premium pour continuer {actions[type] || ''}</div>
                <button onClick={()=>setShowPerks(v=>!v)} className="text-xs font-medium">
                  {showPerks ? 'Masquer' : 'Voir'} les avantages Premium
                </button>
                {showPerks && (
                  <ul className="mt-2 list-disc pl-5 text-xs space-y-0.5">
                    <li>30 recettes par semaine</li>
                    <li>120 suggestions par semaine</li>
                    <li>30 itérations de recettes</li>
                    <li>30 questions à l’expert YAQAM</li>
                    <li>Recettes privées</li>
                    <li>9,99€ / mois — sans engagement</li>
                  </ul>
                )}
              </div>
            )}
          </div>

          <div className="px-5 py-4 border-t border-gray-100 flex items-center justify-end gap-2">
            <button onClick={close} className="px-4 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 text-[#2C3E50]">Fermer</button>
            {type && isFree ? (
              <button onClick={handleUpgrade} disabled={loading} className="px-4 py-2 rounded-lg bg-[#E67E22] text-white hover:bg-[#E67E22]/90">
                {loading ? 'Redirection...' : 'Passer en Premium'}
              </button>
            ) : (
              <button onClick={handleManage} disabled={loading} className="px-4 py-2 rounded-lg bg-[#87A96B] text-white hover:bg-[#87A96B]/90">
                {loading ? 'Ouverture...' : 'Gérer mon abonnement'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
